import React from 'react';
import Container from '../../../containers/integration/apiGroups/showApiGroupContainer';

export default function () {
  return (
    <Container />
  );
}
